import { loadData, saveToCode } from './codeDataStore';

export const DEFAULT_MENU_ITEMS = [
  {
    id: '1',
    label: 'Home',
    path: '/'
  },
  {
    id: '2',
    label: 'About',
    path: '/about-us',
    children: [
      { id: '2.1', label: 'Mission, Vision & Scope', path: '/about-us#mission-vision-scope' },
      { id: '2.2', label: 'Journal Information, Publication History', path: '/about-us#journal-info' },
      { id: '2.3', label: 'Publisher & Institutional Information', path: '/about-us#publisher-info' }
    ]
  },
  {
    id: '3',
    label: 'Aim and Scope',
    path: '/aims-and-scope',
    children: [
      { id: '3.1', label: 'Aim', path: '/aims-and-scope#aim' },
      { id: '3.2', label: 'Scope', path: '/aims-and-scope#scope' },
      { id: '3.3', label: 'Geographical Scope', path: '/aims-and-scope#geographical-scope' },
      { id: '3.4', label: 'Target Audience', path: '/aims-and-scope#target-audience' },
      { id: '3.5', label: 'Editorial Scope and Peer Review', path: '/aims-and-scope#editorial-scope' },
      { id: '3.6', label: 'Article Types', path: '/aims-and-scope#article-types' }
    ]
  },
  {
    id: '4',
    label: 'Editorial Board',
    path: '/editorial-board'
  },
  {
    id: '5',
    label: 'Current Issue',
    path: '/current-issue'
  },
  {
    id: 'call_for_papers',
    label: 'Call for Papers',
    path: '/call-for-papers'
  },
  {
    id: '6',
    label: 'Archives',
    path: '/archives'
  },
  {
    id: '7',
    label: 'Author Guidelines',
    path: '/information-for-authors',
    children: [
      { id: '7.1', label: 'Manuscript Preparation', path: '/information-for-authors#manuscript-preparation' },
      { id: '7.2', label: 'Submission Process', path: '/information-for-authors#submission-process' },
      { id: '7.3', label: 'Article Types', path: '/information-for-authors#article-types' },
      { id: '7.4', label: 'Article Processing Charge (APC)', path: '/information-for-authors#apc' }
    ]
  },
  {
    id: '8',
    label: 'Peer Review Process',
    path: '/peer-review',
    children: [
      { id: '8.1', label: 'Peer Review Process', path: '/peer-review#peer-review' },
      { id: '8.2', label: 'Revision Process', path: '/peer-review#revision' },
      { id: '8.3', label: 'Confidentiality', path: '/peer-review#confidentiality' },
      { id: '8.4', label: 'Reviewer Conflicts of Interest', path: '/peer-review#conflicts' },
      { id: '8.5', label: 'Editorial Independence', path: '/peer-review#independence' }
    ]
  },
  {
    id: '9',
    label: 'Publication Ethics',
    path: '/publication-ethics',
    children: [
      { id: '9.1', label: 'Conflict of Interest', path: '/publication-ethics#conflict-of-interest' },
      { id: '9.2', label: 'Research Ethics', path: '/publication-ethics#research-ethics' },
      { id: '9.3', label: 'Originality & Similarity', path: '/publication-ethics#originality' },
      { id: '9.4', label: 'Plagiarism', path: '/publication-ethics#plagiarism' },
      { id: '9.5', label: 'Corrections', path: '/publication-ethics#corrections' },
      { id: '9.6', label: 'Retractions', path: '/publication-ethics#retractions' }
    ]
  },
  {
    id: '10',
    label: 'Contact',
    path: '/contact',
    children: [
      { id: '10.1', label: 'Journal Contact', path: '/contact#journal-contact' },
      { id: '10.2', label: 'Publisher Contact', path: '/contact#publisher-contact' }
    ]
  }
];

const MENU_UPDATED_EVENT = 'navigation_menu_updated';

/**
 * Ensures 'Current Issue' is present in menu items array
 */
export function ensureCurrentIssueItem(items) {
  if (!Array.isArray(items) || items.length === 0) return items;
  const hasCurrentIssue = items.some(
    (item) => item.path === '/current-issue' || (item.children && item.children.some((c) => c.path === '/current-issue'))
  );
  if (hasCurrentIssue) return items;

  const archivesIdx = items.findIndex((i) => i.path === '/archives');
  const newItem = {
    id: 'current_issue_auto',
    label: 'Current Issue',
    path: '/current-issue'
  };

  const copy = [...items];
  if (archivesIdx !== -1) {
    copy.splice(archivesIdx, 0, newItem);
  } else {
    copy.push(newItem);
  }
  return copy;
}

/**
 * Menu items from public/data/menu.json. Returns DEFAULT_MENU_ITEMS if empty or missing.
 */
export async function getMenuItems() {
  const items = await loadData('menu', null);
  return ensureCurrentIssueItem(Array.isArray(items) && items.length > 0 ? items : DEFAULT_MENU_ITEMS);
}

/**
 * Save menu items into public/data/menu.json (local `npm start` only) and update the header
 */
export async function saveMenuItems(items) {
  await saveToCode('menu', items);
  window.dispatchEvent(new CustomEvent(MENU_UPDATED_EVENT, { detail: items }));
  return true;
}

/**
 * Calls back when the menu is saved from the admin panel. Returns an unsubscribe function.
 */
export function subscribeToMenuItems(callback) {
  const handleUpdate = (e) => {
    if (e.detail && Array.isArray(e.detail)) {
      callback(ensureCurrentIssueItem(e.detail));
    }
  };
  window.addEventListener(MENU_UPDATED_EVENT, handleUpdate);
  return () => window.removeEventListener(MENU_UPDATED_EVENT, handleUpdate);
}
